<!--<div class="container">
    <div class="row">
        <div class="col-sm-3  d-flex flex-column  ">
            <div class="profilepic d-flex flex-column align-items-center border-bottom justify-content-center">-->
<!-- Image Preview -->
<!--<ng-container *ngIf="isImageFile; else videoPreview">
    <img [src]="LoginDetails.imagefile2 ? imagefile2 : HomeUrl + Profile" />
</ng-container>-->
<!-- Video Preview -->
<!--<ng-template #videoPreview>
    <video *ngIf="imagefile2" [src]="imagefile2" controls width="200"></video>
</ng-template>-->
<!--<div class="col-lg-8 mt-2">-->
<!-- Hidden file input -->
<!--<input id="fileInput"
       type="file"
       accept=".jpg,.jpeg,.png,.jfif,.avi,.mov,.mp4"
       (change)="onFileSelected($event)"
       hidden>-->
<!-- Custom button -->
<!--<label for="fileInput" class="btn btn-primary w-100">
    Upload Photo
</label>-->
<!-- Selected file name -->
<!--<small *ngIf="selectedFileName">{{ selectedFileName }}</small>-->
<!--</div>

    <h4 class="mt-4">{{ LoginDetails.FirstName }}</h4>
    <p>{{ LoginDetails.Designation }}</p>
</div>

<div class="row  mt-1   job-status d-flex  justify-content-between">
    <div class="col-sm-12">
        <div class="  d-flex flex-column justify-content-start align-items-start ">
            <ul class="nav-menu">
                <li class="active">
                    <i class="bi bi-briefcase me-2"></i>
                    Dashboard
                </li>
                <li routerLink="/job">
                    <i class="bi bi-person-bounding-box me-2"></i>
                    Jobs
                </li>
                <li routerLink="/CompanyProfile">
                    <i class="bi bi-buildings me-2"></i>
                    Company
                </li>
                <li routerLink="/appliedjobs">
                    <i class="bi bi-window-plus  me-2"></i>
                    Applied Job
                </li>
                <li routerLink="/interviewcalls">
                    <i class="bi bi-telephone me-2"></i>
                    Interview Call
                </li>
                <li>
                    <i class="bi bi-journal me-2"></i>
                    <a href="https://justlivetutors.com/home/courses" target="_blank" style="color: #000000;">Just Live Tutors</a>
                </li>
                <li routerLink="/resumetemplates">
                    <i class="bi-layout-text-sidebar-reverse me-2"></i>
                    Resume Templates
                </li>-->
<!--<li>
    <i class="bi bi-person-square me-2"></i>
    Profile
</li>-->
<!--</ul>

                    </div>
                </div>

            </div>


        </div>

    </div>
</div>-->
<!-- Seeker Menu -->
<div *ngIf="isSeekerLogin" class="d-flex flex-column seekerlogin p-3 border-end">
    <div class="profilepic text-center border-bottom pb-3">
        <h4 class="mt-3">{{ UserDetails?.FirstName }}</h4>
        <p>{{ UserDetails?.Designation }}</p>
    </div>
    <ul class="nav flex-column mt-2">
        <li class="nav-item">
            <a class="nav-link" routerLink="/candidate-dashboard" routerLinkActive="active">
                <i class="bi bi-briefcase me-2"></i> Dashboard
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/CompanyProfile" routerLinkActive="active">
                <i class="bi bi-buildings me-2"></i> Companies
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/job" routerLinkActive="active">
                <i class="bi bi-person-bounding-box me-2"></i> Jobs
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/appliedjobs" routerLinkActive="active">
                <i class="bi bi-window-plus me-2"></i> Applied Jobs
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/interviewcalls" routerLinkActive="active">
                <i class="bi bi-telephone me-2"></i> Interview Scheduled
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/onboardclients" routerLinkActive="active">
                <i class="bi bi-buildings me-2"></i> On-Boarding Clients
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/resumetemplates" routerLinkActive="active">
                <i class="bi bi-layout-text-sidebar-reverse me-2"></i> Resume Templates
            </a>
        </li>
        <li class="nav-item">
            <a href="https://justlivetutors.com/home/courses" target="_blank" class="nav-link">
                <i class="bi bi-journal me-2"></i> Just Live Tutors
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" routerLink="/support" routerLinkActive="active">
                <i class="bi bi-info-square me-2"></i> Support
            </a>
        </li>
        <li class="nav-item" (click)="Logout()">
            <a class="nav-link"  routerLinkActive="active">
                <i class="bi bi-box-arrow-left me-2"></i> Log Out
            </a>
        </li>
    </ul>
</div>

<!-- Company Menu -->
<div *ngIf="isCompanyLogin" class="d-flex flex-column vh-100 p-3 border-end">
    <div class="col-12 p-0 mt-5 pt-5">
        <div class="d-flex flex-column justify-content-start align-items-start">
            <ul class="nav flex-column mt-2">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/company-dashboard" routerLinkActive="active">
                        <i class="bi bi-briefcase me-2"></i> Dashboard
                    </a>
                </li>

                <!--<li class="nav-item">
        <a class="nav-link" routerLink="/interviewcalls" routerLinkActive="active">

        </a>
    </li>-->

                <li class="nav-item dropdown-toggles" data-bs-toggle="dropdown">
                    <a class="nav-link">
                        <i class="bi bi-buildings me-2"></i> Company Profile
                    </a>
                </li>
                <ul class="dropdown-menu">
                    <li class="nav-item m-0">
                        <a class="nav-link" routerLink="/company-account" routerLinkActive="active">
                            <i class="bi bi-buildings me-3"></i>Company Detail
                        </a>
                    </li>
                    <!--<li class="dropdown-item">Company Detail</li>-->
                    <li class="nav-item m-0">
                        <a class="nav-link" routerLink="/Subscription" routerLinkActive="active">
                            <i class="bi bi-wallet-fill me-3"></i>Subscription Detail
                        </a>
                    </li>
                </ul>

                <li class="nav-item dropdown-toggles" data-bs-toggle="dropdown">
                    <a class="nav-link">
                        <i class="bi bi-postcard me-2"></i> Post Jobs
                    </a>
                </li>
                <ul class="dropdown-menu">
                    <li class="nav-item m-0">
                        <a class="nav-link" routerLink="/postjobs" routerLinkActive="active">
                            <i class="bi bi-postcard me-3"></i>Post Jobs
                        </a>
                    </li>
                    <!--<li class="dropdown-item">Company Detail</li>-->
                    <li class="nav-item m-0">
                        <a class="nav-link" routerLink="/Managejobs" routerLinkActive="active">
                            <i class="bi bi-journal-text me-3"></i>Manage Jobs
                        </a>
                    </li>
                </ul>

                <li class="nav-item dropdown-toggles" data-bs-toggle="dropdown">
                    <a class="nav-link">
                        <i class="bi bi-layout-text-sidebar-reverse me-2"></i> Candidates Resume
                    </a>
                </li>
                <ul class="dropdown-menu">
                    <li class="nav-item m-0">
                        <a class="nav-link"
                           [routerLink]="['/candidatesdetails']"
                           [queryParams]="{ tab: 'pendingDetail' }"
                           routerLinkActive="active">
                            <i class="bi bi-hourglass me-3"></i> Pending
                        </a>
                    </li>

                    <li class="nav-item m-0">
                        <a class="nav-link"
                           [routerLink]="['/candidatesdetails']"
                           [queryParams]="{ tab: 'selectedDetail' }"
                           routerLinkActive="active">
                            <i class="bi bi-check-circle me-3"></i> Selected List
                        </a>
                    </li>

                    <li class="nav-item m-0">
                        <a class="nav-link"
                           [routerLink]="['/candidatesdetails']"
                           [queryParams]="{ tab: 'rejectDetail' }"
                           routerLinkActive="active">
                            <i class="bi bi-dash-circle me-3"></i> Rejected
                        </a>
                    </li>
                </ul>


                <li class="nav-item">
                    <a class="nav-link" routerLink="/businessnetwork" routerLinkActive="active">
                        <i class="bi bi-people me-2"></i> Business Network
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/transactions" routerLinkActive="active">
                        <i class="bi bi-cash me-2"></i> Transactions
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/support" routerLinkActive="active">
                        <i class="bi bi-info-square me-2"></i> Support
                    </a>
                </li>
                <li class="nav-item" (click)="Logout()">
                    <a class="nav-link">
                        <i class="bi bi-box-arrow-left me-2"></i> Logout
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>
